import React from 'react'
import Header from '.'

interface Props {

}

const AdminHeader: React.FC<Props> = () => {
  return (
    <Header
      position="sticky"
      withoutLogo
      right
      noBurgerOnMobile
    />
  )
}

export default AdminHeader
